export const ADD_ERROR_ALERT = 'add_error_alert';
export const ADD_SUCCESS_ALERT = 'add_success_alert';
export const ADD_INFO_ALERT = 'add_info_alert';
export const REMOVE_ERROR_ALERT = 'remove_error_alert';
export const REMOVE_SUCCESS_ALERT = 'remove_success_alert';
export const REMOVE_INFO_ALERT = 'remove_info_alert';
